import {
  ConfirmPopover,
  ContentPanel,
  Icon,
  StoryContent,
  Toolbar
} from '../../components'
import { Link, useNavigate, useParams } from 'react-router-dom'
import { Button, ButtonGroup } from 'react-bootstrap'
import { useAffiliation, useDeleteStoryMutation } from '../../hooks'
import { PERMISSION } from '../../helpers'
import {
  faChevronLeft,
  faPen,
  faTrash
} from '@fortawesome/free-solid-svg-icons'

export const StoryDisplay = ({
  category,
  story,
  onToggleEdit,
  title,
  content,
  changed
}) => {
  const { tenantUrlSlug, affiliationUrlSlug, categoryUrlSlug } = useParams()
  const navigate = useNavigate()
  const { affiliation } = useAffiliation()
  const permissions = affiliation?.permissions || []
  const canEdit = permissions.includes(PERMISSION.EDIT)

  const { mutate: deleteStory } = useDeleteStoryMutation()

  const onDelete = () =>
    deleteStory(
      { categoryId: category.id, storyId: story.id },
      {
        onSuccess: () =>
          navigate(`/${tenantUrlSlug}/${affiliationUrlSlug}/${categoryUrlSlug}`)
      }
    )

  return (
    <>
      <Toolbar title={category.name} />
      <ContentPanel className='story-panel'>
        <article aria-labelledby='story-title'>
          <header className='d-flex justify-content-between align-items-center mb-3'>
            <h2 id='story-title'>{title}</h2>
            <nav aria-label='Story actions'>
              <ButtonGroup>
                {canEdit ? (
                  <ButtonGroup>
                    <Button
                      onClick={onToggleEdit}
                      aria-label='Edit'
                      title='Edit Story'
                      variant='link'
                    >
                      <Icon icon={faPen} size='lg' />
                      {changed ? '* ' : null}Edit{' '}
                    </Button>
                    {story.id ? (
                      <ConfirmPopover id='delete-story' onConfirm={onDelete}>
                        <Button
                          aria-label='Delete'
                          title='Delete Story'
                          variant='link'
                        >
                          <Icon icon={faTrash} size='lg' />
                          {changed ? '* ' : null}Delete{' '}
                        </Button>
                      </ConfirmPopover>
                    ) : null}
                  </ButtonGroup>
                ) : null}
                {changed ? null : (
                  <>
                    {canEdit && (
                      <span className='mx-1 text-muted align-self-center h5 mb-0'>
                        |
                      </span>
                    )}
                    <Button
                      as={Link}
                      to={`/${tenantUrlSlug}/${affiliationUrlSlug}/${categoryUrlSlug}`}
                      variant='link'
                      title='Cancel and go back'
                    >
                      <Icon
                        icon={faChevronLeft}
                        size='lg'
                        className='fa-w-12'
                      />
                      Back
                    </Button>
                  </>
                )}
              </ButtonGroup>
            </nav>
          </header>
          <StoryContent
            content={content}
            className='story-content contain-floats'
          />
        </article>
      </ContentPanel>
    </>
  )
}
